// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationGroupId } from './FermentationGroup';
import { fermentationId } from './Fermentation';
import { brewcontrolNodeId } from './BrewcontrolNode';
import { fermentationGroupAlertId } from './FermentationGroupAlert';
import { fermentationAlertKindEnum } from './FermentationAlertKindEnum';
import { fermentationAlertStateEnum } from './FermentationAlertStateEnum';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationAlertId = (z.number());
export const fermentationAlert = z.object({
    id: fermentationAlertId,
    fermentation_group_id: fermentationGroupId,
    fermentation_id: fermentationId.nullable(),
    brewcontrol_node_id: brewcontrolNodeId.nullable(),
    group_alert_id: fermentationGroupAlertId.nullable(),
    kind: fermentationAlertKindEnum,
    state: fermentationAlertStateEnum,
    dedupe_key: z.string(),
    detail: z.string(),
    observed_value: z.string().nullable(),
    raised_at: z.date(),
    acked_at: z.date().nullable(),
    acked_by: operatorId.nullable(),
    cleared_at: z.date().nullable(),
    self_cleared: z.boolean(),
    sms_sent_at: z.date().nullable(),
    voice_sent_at: z.date().nullable(),
});
export const fermentationAlertInitializer = z.object({
    id: fermentationAlertId.optional(),
    fermentation_group_id: fermentationGroupId,
    fermentation_id: fermentationId.optional().nullable(),
    brewcontrol_node_id: brewcontrolNodeId.optional().nullable(),
    group_alert_id: fermentationGroupAlertId.optional().nullable(),
    kind: fermentationAlertKindEnum,
    state: fermentationAlertStateEnum.optional(),
    dedupe_key: z.string(),
    detail: z.string(),
    observed_value: z.string().optional().nullable(),
    raised_at: z.date().optional(),
    acked_at: z.date().optional().nullable(),
    acked_by: operatorId.optional().nullable(),
    cleared_at: z.date().optional().nullable(),
    self_cleared: z.boolean().optional(),
    sms_sent_at: z.date().optional().nullable(),
    voice_sent_at: z.date().optional().nullable(),
});
export const fermentationAlertMutator = z.object({
    id: fermentationAlertId.optional(),
    fermentation_group_id: fermentationGroupId.optional(),
    fermentation_id: fermentationId.optional().nullable(),
    brewcontrol_node_id: brewcontrolNodeId.optional().nullable(),
    group_alert_id: fermentationGroupAlertId.optional().nullable(),
    kind: fermentationAlertKindEnum.optional(),
    state: fermentationAlertStateEnum.optional(),
    dedupe_key: z.string().optional(),
    detail: z.string().optional(),
    observed_value: z.string().optional().nullable(),
    raised_at: z.date().optional(),
    acked_at: z.date().optional().nullable(),
    acked_by: operatorId.optional().nullable(),
    cleared_at: z.date().optional().nullable(),
    self_cleared: z.boolean().optional(),
    sms_sent_at: z.date().optional().nullable(),
    voice_sent_at: z.date().optional().nullable(),
});
//# sourceMappingURL=FermentationAlert.js.map